import { Component } from "react";
import Parse from "parse";
import { Text, Box, Button } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import debug from "src/modules/debug-logger";
import { H2 } from "src/atoms/typography";
import { SceneLayout } from "src/components/SceneLayout";
import TextField from "src/components/TextField";
import LoadableContent from "src/components/LoadableContent";
import Dialog from "src/components/Dialog";
import IconOnBackground from "src/components/IconOnBackground";
import NavigationButtons from "src/components/NavigationButtons";
import ShowPassword from "src/components/ShowPassword";
import { ReactComponent as FamilyIcon } from "./family.svg";

const log = window.require("electron-log");

class SignUp extends Component {
  state = {
    familyName: this.props.familyName || "",
    email: this.props.email || "",
    password: "",
    isProcessing: false,
    error: false,
    showPassword: false
  };
  handleInputChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };
  toggleShowPassword = () =>
    this.setState((prev) => ({ showPassword: !prev.showPassword }));

  handleSubmit = async (e) => {
    e.preventDefault();
    const { onSuccess, signUp } = this.props;
    const { email, password, familyName, isProcessing } = this.state;
    if (isProcessing) {
      return;
    }
    this.setState({ isProcessing: true, error: false, emailTaken: false });

    try {
      await signUp({
        email,
        password,
        familyName
      });
      onSuccess();
    } catch (error) {
      const { code } = error;
      code && debug.auth("SignUp error code", error.code);
      log.error(error);
      if (
        code === Parse.Error.EMAIL_TAKEN ||
        code === Parse.Error.USERNAME_TAKEN
      ) {
        this.setState({
          isProcessing: false,
          emailTaken: true
        });
      } else {
        this.setState({
          isProcessing: false,
          error: true
        });
      }
    }
  };
  closeErrorDialog = () => this.setState({ error: false });

  render() {
    const {
      t,
      onBack,
      onClose,
      openLogin,
      showAlreadyHaveAccount = true,
      mode
    } = this.props;
    const {
      familyName,
      password,
      email,
      isProcessing,
      emailTaken,
      error,
      showPassword
    } = this.state;

    return (
      <>
        <Dialog
          isOpen={error}
          type="failure"
          heading={t("auth.signUp.failureDialog.heading")}
          buttons={[
            {
              text: t("buttons.ok"),
              onClick: this.closeErrorDialog
            }
          ]}
        />
        <NavigationButtons mode={mode} onBack={onBack} onClose={onClose} />
        <SceneLayout
          as="form"
          onSubmit={this.handleSubmit}
          centerProps={{
            width: "320px"
          }}
          center={
            <>
              <IconOnBackground
                fill="primary"
                icon={FamilyIcon}
                bg="primaryLight"
              />
              <H2 textAlign="center" color="highEmphasis" mt="24px">
                {t("auth.signUp.heading")}
              </H2>
              <Box width="100%" mt="16px">
                <TextField
                  name="email"
                  type="email"
                  inputProps={{
                    autoComplete: "email"
                  }}
                  onChange={this.handleInputChange}
                  required
                  value={email}
                  disabled={isProcessing}
                  placeholder={t("placeholders.email")}
                  mt="16px"
                />
              </Box>
              {emailTaken && (
                <Text fontSize="11px" mt="4px" mb="8px" color="red">
                  {t("auth.signUp.emailInUse")}
                </Text>
              )}
              <Box width="100%" mt="16px" position="relative">
                <TextField
                  type={showPassword ? "text" : "password"}
                  name="password"
                  inputProps={{
                    minLength: 5,
                    autoComplete: "current-password"
                  }}
                  disabled={isProcessing}
                  placeholder={t("placeholders.password")}
                  required
                  value={password}
                  mt="16px"
                  onChange={this.handleInputChange}
                />
                <ShowPassword
                  onChange={this.toggleShowPassword}
                  showPassword={showPassword}
                />
              </Box>
              <Box width="100%" mt="16px">
                <TextField
                  name="familyName"
                  value={familyName}
                  onChange={this.handleInputChange}
                  type="text"
                  required
                  disabled={isProcessing}
                  placeholder={t("placeholders.familyName")}
                  mt="16px"
                />
              </Box>
            </>
          }
          bottomProps={{ mb: "24px" }}
          bottom={
            <>
              <Button
                variant="containedPrimary"
                disabled={isProcessing}
                type="submit"
                minWidth="120px"
              >
                {t("buttons.create")}
              </Button>
              <LoadableContent
                showSpinner={isProcessing}
                showContent={!isProcessing && showAlreadyHaveAccount}
              >
                <Button
                  variant="flatPrimary"
                  mt="8px"
                  disabled={isProcessing}
                  type="button"
                  onClick={openLogin}
                >
                  {t("buttons.alreadyHaveFamilyAccount")}
                </Button>
              </LoadableContent>
            </>
          }
        />
      </>
    );
  }
}

export default withTranslation()(SignUp);
